// 代码运行环境判断
const evn = () => {
  if (typeof window === 'undefined') {
    return 'node';
  }

  const UA = window.navigator.userAgent.toLowerCase();

  if (window.__wxjs_environment === 'miniprogram') {
    return 'miniprogram';
  }

  if (UA.match(/MicroMessenger/i)) {
    return 'wechat';
  }

  if (UA.match(/ZhongAnWebView/i)) {
    return 'za';
  }

  if (UA.match(/ifuli/i)) {
    return 'ifuli';
  }

  if (window.iHealthBridge && (window.iHealthBridge.app_name === 'iyunbao' || typeof window.iHealthBridge.app_name === 'function' && window.iHealthBridge.app_name() === 'iyunbao')) {
    return 'iyunbao';
  }

  return 'browser';
};

export const runEnv = evn();